module.exports = __webpack_public_path__ + "media/shape/menu-fbfd7497.png";